query InvitationStatisticsForCompany($input: GetInvitationStatisticsInput!) {
  invitationStatisticsForCompany(input: $input) {
    conversions
    total
    invitationsPerLandingpage {
      conversions
      landingpageSlug
      landingpageName
      total
    }
  }
}
